var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tags-academy"}},[_c('div',{staticClass:"tag",on:{"click":function($event){return _vm.deleteEvent()}}},[_vm._v(_vm._s(_vm.tag)+" "),_c('span',[_vm._v("x")])])])}
var staticRenderFns = []

export { render, staticRenderFns }